import { render, staticRenderFns } from "./OrganisationRegistrationForm.vue?vue&type=template&id=6235d14a&"
import script from "./OrganisationRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./OrganisationRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports